
export default class TransactionChangeDetailsRequestModel {
    public checkNumber: string = '';
    public transactionDescription: string = '';
    public transactionDate?: Date;
}
